import { render, staticRenderFns } from "./chooseData.vue?vue&type=template&id=4d4ba209&scoped=true"
import script from "./chooseData.vue?vue&type=script&lang=js"
export * from "./chooseData.vue?vue&type=script&lang=js"
import style0 from "./chooseData.vue?vue&type=style&index=0&id=4d4ba209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ba209",
  null
  
)

export default component.exports